export default __webpack_public_path__ + "static/media/54_mobile.823cb6cc.jpg";